import { Link } from 'react-router-dom';
import { useLanguage } from '@/contexts/LanguageContext';

const Footer = () => {
  const { t } = useLanguage();

  return (
    <footer className="bg-stone-800 text-stone-300">
      <div className="max-w-6xl mx-auto px-6 py-14">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-10 mb-10">
          <div>
            <div className="flex items-center gap-2.5 mb-4">
              <div className="w-8 h-8 flex items-center justify-center">
                <img
                  src="https://static.readdy.ai/image/87a8138ca64b05ac1815bceaa72b9a44/a014d93886c6c08d90290cad256e4f3a.png"
                  alt="Logo"
                  className="w-full h-full object-contain opacity-90"
                />
              </div>
              <div>
                <p className="text-sm font-bold text-stone-100">LUVing</p>
              </div>
            </div>
            <p className="text-xs text-stone-400 leading-relaxed">
              {t(
                'I am currently studying in the United States on F-1 student visa. While I in the U.S., I do not accept paid collaborations, advertising, sponsorships, or other compensated commercial arrangements. General inquiries and non-commercial contact are always welcome.',
                '저는 현재 F-1 비자로 미국에서 유학 중인 학생 신분으로, 미국에 있는 기간은 금전적 보수를 수반하는 협업, 광고, 스폰서십 및 기타 상업적 제안은 진행하지 않습니다. 일반적 문의와 금전적 보수를 수반하지 않는 연락은 언제든지 환영합니다.'
              )}
            </p>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-4">
              {t('Navigate', '탐색')}
            </h4>
            <div className="space-y-2">
              {[
                { to: '/', label: t('Home', '홈') },
                { to: '/about', label: t('About', '소개') },
                { to: '/issues', label: t('Posts', '게시물') },
              ].map(({ to, label }) => (
                <Link
                  key={to}
                  to={to}
                  className="block text-sm text-stone-400 hover:text-stone-100 transition-colors cursor-pointer"
                >
                  {label}
                </Link>
              ))}
            </div>
          </div>

          <div>
            <h4 className="text-xs font-semibold text-stone-400 uppercase tracking-widest mb-4">
              {t('Topics', '주제')}
            </h4>
            <div className="flex flex-wrap gap-2">
              {['Global Affairs', 'International Order', 'Rights and Freedoms', 'Politics', 'Justice and Freedom', 'Law and Society'].map((topic) => (
                <Link
                  key={topic}
                  to={`/issues?category=${encodeURIComponent(topic)}`}
                  className="text-xs px-2.5 py-1 border border-stone-600 rounded-full text-stone-400 hover:text-stone-200 hover:border-stone-400 transition-colors cursor-pointer whitespace-nowrap"
                >
                  {topic}
                </Link>
              ))}
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
